// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__OUg73"};